/*
  從「小芋頭服務」選單整頁跳到另一個網站（社群、AI 站…）時，先蓋一層「前往中」。

  整頁跳轉在新網站畫出來之前，畫面會一直停在原頁，看起來像按了沒反應。
  App 剛裝好、什麼都還沒快取時要等好幾秒（2026-10-30 回報「點了卡在當前畫面」）。
  按下去就先蓋上，讓人知道在跑。

  - 只給「同一個視窗整頁跳轉」用。開新分頁（_blank）原頁不會離開，蓋了就拿不掉
  - 按返回回到這一頁時，瀏覽器的往返快取會把整頁連遮罩一起還原 → pageshow 時拿掉
  - 網址只差 # 不會換頁；跳轉失敗（斷線）也不會換頁 → 這兩種不蓋、或過一陣子自己拿掉
*/

const OVERLAY_ID = "taro-leaving-overlay";
const GIVE_UP_MS = 20000;

let giveUpTimer = null;

function removeOverlay() {
  const el = document.getElementById(OVERLAY_ID);
  if (el) el.remove();
  if (giveUpTimer) clearTimeout(giveUpTimer);
  giveUpTimer = null;
}

window.addEventListener("pageshow", (event) => {
  if (event.persisted) removeOverlay();
});

/** 選單的名稱可能帶 <br>（後台的換行、Google Sheet 的 HTML）：轉成純文字。DOMParser 產生的文件不會執行任何東西 */
function toPlainText(html) {
  try {
    const text = new DOMParser().parseFromString(String(html || "").replace(/<br\s*\/?>/gi, " "), "text/html").body.textContent;
    return text.replace(/\s+/g, " ").trim();
  } catch (e) {
    return "";
  }
}

/** 只差在 # 的網址不會換頁 */
function isSamePage(url) {
  try {
    const target = new URL(url, window.location.href);
    const here = new URL(window.location.href);
    target.hash = "";
    here.hash = "";
    return target.href === here.href;
  } catch (e) {
    return false;
  }
}

/** 蓋上「正在前往 {name}…」，然後整頁跳到 url */
export function leaveTo(url, name) {
  if (!isSamePage(url)) showOverlay(toPlainText(name));
  window.location.href = url;
}

function showOverlay(name) {
  removeOverlay();

  const overlay = document.createElement("div");
  overlay.id = OVERLAY_ID;
  overlay.setAttribute("role", "status");
  overlay.setAttribute("aria-live", "polite");
  overlay.style.cssText = [
    "position:fixed",
    "top:0", // 不用 inset：舊的 Android WebView 不認得
    "right:0",
    "bottom:0",
    "left:0",
    "z-index:10000", // 小芋頭助手是 9999
    "display:flex",
    "flex-direction:column",
    "align-items:center",
    "justify-content:center",
    "padding:0 24px",
    "background:rgba(255,255,255,0.92)",
    "color:#424242",
    "font-size:15px",
    "line-height:1.5",
    "text-align:center",
  ].join(";");

  const spinner = document.createElement("div");
  spinner.style.cssText = "width:40px;height:40px;border-radius:50%;border:4px solid #e9d5ff;border-top-color:#9333ea;animation:taro-leaving-spin 0.8s linear infinite";

  const label = document.createElement("div");
  label.style.marginTop = "16px"; // 不用 flex 的 gap：舊的 Android WebView 不支援
  label.textContent = name ? `正在前往「${name}」…` : "載入中…";

  const style = document.createElement("style");
  style.textContent = "@keyframes taro-leaving-spin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){#" + OVERLAY_ID + " div{animation-duration:2.4s!important}}";

  overlay.append(style, spinner, label);
  document.body.appendChild(overlay);

  giveUpTimer = setTimeout(removeOverlay, GIVE_UP_MS);
}
